import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function PrivacyStatement() {
  return (
    <div id="layoutDefault_content">
      <div id="layoutDefault">
        <div id="layoutDefault_content">
          <main>
            <Navbar />
            <section
              className="bg-white py-10 mt-10"
              style={{ fontFamily: "Lato" }}
            >
              <div className="container md:px-15 px-5">
                <h2 className="mb-4">Privacy Statement</h2>
                <p className="lead">
                  We respect your privacy and take the protection of your
                  personal information seriously. Any information collected
                  through this website is used only to improve your experience
                  and the services we provide. We do not share or sell your
                  information to third parties, unless required by law or with
                  your explicit consent.
                </p>
              </div>
            </section>
          </main>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default PrivacyStatement;
